import React from "react";

export default function SQLServer_CONVERT() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQLServer_CONVERT</h1>
      <p>This is the SQLServer_CONVERT component generated from the SQL JSON.</p>
    </div>
  );
}
